module.exports = __webpack_public_path__ + "static/media/111.fcbd7617.svg";